import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import dayjs from 'dayjs'
import './assets/css/global.css'
import './assets/css/zcy.css'
import axios from 'axios'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import {zhTran} from './assets/js/zh'
Vue.prototype.$zhTran = zhTran
// import VueI18n from 'vue-i18n'
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
// Vue.use(VueI18n)
//配置请求的根路径
// axios.defaults.baseURL = 'https://www.sztmas.cn/jehc-web-app/'
// axios.defaults.baseURL = 'http://192.168.50.107:8089/jehc-web-app'
axios.defaults.baseURL = 'https://api2.ts960.com/jehc-web-app/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;

Vue.prototype.$http = axios
const imgUrl = 'https://qinius.ts960.com/'
Vue.prototype.$imgUrl = imgUrl
Vue.prototype.$dayjs = dayjs

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
